import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AuthService } from 'src/app/shared/service/auth.service';
import * as firebase from 'firebase';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-super-admin-dashboard',
  templateUrl: './super-admin-dashboard.component.html',
  styleUrls: ['./super-admin-dashboard.component.scss'],
})
export class SuperAdminDashboardComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'email',
    'companyName',
    'typeOfUser',
    'AdminCode',
    'Actions',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  userData: firebase.User;
  dbstoreSub: Subscription;
  constructor(
    private authService: AuthService,
    private dbstore: AngularFirestore,
    private cd: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit() {
    this.userData = this.authService.userData;
    this.dbstoreSub = this.dbstore
      .collection('users', (ref) => ref.where('typeOfUser', '==', 'Admin'))
      .get()
      .subscribe((payload) => {
        const tab = [];
        !payload.empty &&
          payload.docs.forEach((doc) => doc.exists && tab.push(doc.data()));
        this.dataSource = new MatTableDataSource(tab);
        this.dataSource.paginator = this.paginator;
        this.cd.detectChanges();
      });
  }

  routeToDetail(uid: string, adminCode: string) {
    this.router.navigate(['super-admin', 'admin-details', adminCode, uid]);
  }

  ngOnDestroy() {
    this.dbstoreSub?.unsubscribe();
  }
}
